import { FC } from 'react';
import { SidebarBase } from '../common';
import { useSidebarItems } from '../common/hooks';
import { ExternalSidebarClassNames } from './ExternalSidebar.styles';

type SidebarNavigationProps = {
  className?: string;
};

export const ExternalSidebarNavigation: FC<SidebarNavigationProps> = ({ className }) => {
  const items = useSidebarItems();

  return (
    <SidebarBase.Navigation className={className}>
      <div className='grow'>
        {items.map((item) => (
          <SidebarBase.NavItem key={item.path} {...item} classNames={ExternalSidebarClassNames} />
        ))}
      </div>
    </SidebarBase.Navigation>
  );
};
